import { STATUS } from "@/constants/statuses";
import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { Observable, map } from "rxjs";

import { ProductSdkDto, ProductVariantSdkDto } from "../types";
import { mapProductToSdkDto } from "../utils/mapProductToSdkDto";
import { mapProductVariantToSdkDto } from "../utils/mapProductVariantToSdkDto";

export class ProductsStateKitQueryWrapper {
    constructor(private readonly productsQuery: ProductsQuery) {}

    selectAll(): Observable<ProductSdkDto[]> {
        return this.productsQuery
            .selectAll()
            .pipe(map((products) => products.map(mapProductToSdkDto)));
    }

    selectProduct(productId: number): Observable<ProductSdkDto | null> {
        return this.productsQuery.selectProduct(productId).pipe(
            map((product) => {
                if (!product) return null;
                return mapProductToSdkDto(product);
            })
        );
    }

    selectProductAndVariant(
        productId: number,
        variantId: number | null
    ): Observable<{
        product?: ProductSdkDto;
        variant?: ProductVariantSdkDto;
    }> {
        return this.productsQuery
            .selectProductAndVariant(productId, variantId)
            .pipe(
                map((result) => ({
                    product: result.product
                        ? mapProductToSdkDto(result.product)
                        : undefined,
                    variant: result.variant
                        ? mapProductVariantToSdkDto(result.variant)
                        : undefined,
                }))
            );
    }

    selectProductIds(): Observable<number[]> {
        return this.productsQuery.selectProductIds();
    }

    selectProductStatus(
        productId: number
    ): Observable<STATUS.LOADING | STATUS.READY | "IN_QUEUE" | undefined> {
        return this.productsQuery.selectProductStatus(productId);
    }

    selectFirstVariantOfProduct(
        productId: number
    ): Observable<ProductVariantSdkDto | null> {
        return this.productsQuery.selectFirstVariantOfProduct(productId).pipe(
            map((variant) => {
                if (!variant) return null;
                return mapProductVariantToSdkDto(variant);
            })
        );
    }
}
